/**
 *  @fileOverview Scrollspy module, initalises scrollspy on side nav
 *
 *  @author       Chris Hill
 *
 */

function ScrollspyModule () {
  /**
   * @description Initialises scrollspy.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  this.init = function () {
    /**
     * Define nav aside and sections
     */
    const nav = document.querySelector('.internalNav')
    const aside = document.querySelector('.aside')
    const fswrapper = document.querySelector('.futureStudentsWrapper')
    var section = document.querySelectorAll('[data-scrollspy]')
    var sections = {}
    var i = 0
    let mobileoset = 0
    let wrapperoset = 0 // offset var for new design

    if (nav !== null) {
      /**
       * Account for height of aside nav if it isn't sitting on the right hand side eg full screen
       */
      if (aside !== null) {
        if (aside.offsetLeft === 0) {
          mobileoset = aside.offsetHeight
        }
      }

      /**
       * Account for offset on new page styles that use futureStudentsWrapper
       */
      if (fswrapper !== null) {
        wrapperoset = document.querySelector('.futureStudentsWrapper').offsetTop
      }

      /**
       * Manually add in overview -- future fix is to add studySection class to all overview elements
       */
      /* const overview = document.querySelector('#overview')
      if (typeof overview !== 'undefined' && overview !== null) {
        sections['overview'] = overview.offsetTop - mobileoset
      } */

      /**
       * Create object with id as key and offsettop as value
       */
      Array.prototype.forEach.call(section, function (e) {
        /**
         * Check if there is a matching menu item in the side nav
         */
        if (nav.querySelector('a[href="#' + e.dataset.scrollspy + '"]') !== null) {
          /**
           * Check if item is not events or if event it is not hidden or if on new design
           */
          if (fswrapper !== null || (e.dataset.scrollspy !== 'events')) {
            sections[e.id] = e.offsetTop - mobileoset + wrapperoset
          }
        }
      })

      /**
       * @description On window scroll if window position greater than section offset set as active element.
       *
       * @example
       * //
       * @returns {boolean} // null.
       */
      window.onscroll = function () {
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop
        let headerOSet = 0

        /**
         * Check for header and add height to calc
         */
        if (document.querySelector('.header') !== null) {
          headerOSet = document.querySelector('.header').offsetHeight
        }

        for (i in sections) {
          if (sections[i] <= scrollPosition + headerOSet) { // Plus 10 just to give a little margin of error
            /**
             * Make sure element exist before removing class
             */
            if (nav.querySelector('.internalNav__anchor--active') !== null) {
              nav.querySelector('.internalNav__anchor--active').classList.remove('internalNav__anchor--active')
            }

            nav.querySelector('a[href="#' + i + '"]').classList.add('internalNav__anchor--active')

            if (aside.offsetLeft === 0) {
              const list = nav.querySelector('.internalNav__list')
              const item = nav.querySelector('.internalNav__anchor--active').parentElement

              list.scrollLeft = item.offsetLeft
            }
          }
        }
      }
    }
  }
}

module.exports = ScrollspyModule
